/* eslint-disable @typescript-eslint/no-explicit-any */
export const callApi = async (
  url: string,
  method = "GET",
  headers_additional = {},
  credentials: RequestCredentials = "same-origin",
  body: any | null = null,
  returnJson: boolean = true,
  convertBodyInJson: boolean = true
): Promise<any> => {
  const reponse = await fetch(url, {
    method: method,
    headers: {
      Accept: "application/json",
      ...headers_additional,
    },
    credentials: credentials,
    body: body ? (convertBodyInJson ? JSON.stringify(body) : body) : null,
  });
  if (!reponse.ok) {
    const error = await reponse.json();
    console.log(error);
    throw new Error(
      reponse.status + " " + reponse.statusText + " " + error?.detail
    );
  }

  const jsonReponse = returnJson ? reponse.json() : reponse;
  return jsonReponse;
};

export const getDataMock = (): boolean => {
  return import.meta.env.VITE_APP_USE_MOCK === "true";
};
